import { Injectable } from '@angular/core';
import { TreeviewItem } from '../../../shared/components/tree-view/treeview-item';
import { BaseApiService } from '../../../shared/services/api';
import { Observable } from 'rxjs';

export const TechIntelCategoryData = [new TreeviewItem({
    text: 'Advertising', value: 1, checked: false, collapsed: true, children: [
        { text: 'Ad Exchanges', value: 2, checked: false },
        { text: 'Publisher Ad Management Software', value: 3, checked: false },
        { text: 'Advertiser Campaign Management', value: 4, checked: false },
        { text: 'Data Management Platforms (DMP)', value: 5, checked: false },
        { text: 'Video Advertising Platforms', value: 6, checked: false },
        { text: 'Other Advertising Software', value: 7, checked: false }
    ]
}), new TreeviewItem({
    text: 'Analytics', value: 21, checked: false, collapsed: true, children: [
        { text: 'Reporting Tools', value: 22, checked: false },
        { text: 'Monitoring & Analytics Tools', value: 23, checked: false },
        { text: 'Enterprise Performance Management (EPM)', value: 24, checked: false },
        { text: 'Business Intelligence (BI)', value: 25, checked: false },
        { text: 'Enterprise Search', value: 26, checked: false },
        { text: 'Web Analytics', value: 27, checked: false },
        { text: 'Predictive Analytics', value: 28, checked: false },
        { text: 'Other Analytics', value: 29, checked: false }
    ]
}), new TreeviewItem({
    text: 'Collaboration and Productivity', value: 41, checked: false, collapsed: true, children: [
        { text: 'Email Software', value: 42, checked: false },
        { text: 'Team Collaboration and Business IM', value: 43, checked: false },
        { text: 'Productivity / Office Tools', value: 44, checked: false },
        { text: 'Audio and Video Conferencing', value: 45, checked: false },
        { text: 'Other Collaboration and Productivity', value: 46, checked: false }
    ]
}), new TreeviewItem({
    text: 'Commerce', value: 61, checked: false, collapsed: true, children: [
        { text: 'E-Commerce Platforms (ECP)', value: 62, checked: false },
        { text: 'Points of Sales (POS)', value: 63, checked: false },
        { text: 'Payment Processing', value: 64, checked: false },
        { text: 'Shopping Carts', value: 65, checked: false },
        { text: 'Other Commerce', value: 66, checked: false }
    ]
}), new TreeviewItem({
    text: 'Communication', value: 81, checked: false, collapsed: true, children: [
        { text: 'Communications Management', value: 82, checked: false },
        { text: 'VoIP', value: 83, checked: false },
        { text: 'Other Communication tools', value: 84, checked: false }
    ]
}), new TreeviewItem({
    text: 'Content Management', value: 101, checked: false, collapsed: true, children: [
        { text: 'Enterprise Content Management (ECM)', value: 102, checked: false },
        { text: 'Online Video Platforms (OVP)', value: 103, checked: false },
        { text: 'Online Form Builders', value: 104, checked: false },
        { text: 'Web Content Management Systems (WCMS)', value: 105, checked: false },
        { text: 'Content Delivery Networks (CDN)', value: 106, checked: false },
        { text: 'Domain Name Services (DNS)', value: 107, checked: false },
        { text: 'Web Hosting', value: 108, checked: false },
        { text: 'Comment Systems', value: 109, checked: false },
        { text: 'Website Builders', value: 110, checked: false },
        { text: 'Mapping and GIS', value: 111, checked: false },
        { text: 'Other Content Management', value: 112, checked: false }
    ]
}), new TreeviewItem({
    text: 'Customer Service', value: 121, checked: false, collapsed: true, children: [
        { text: 'Contact Center Solutions', value: 122, checked: false },
        { text: 'Help Desk', value: 123, checked: false },
        { text: 'Field Service Management (FSM)', value: 124, checked: false },
        { text: 'Live Chats', value: 125, checked: false },
        { text: 'Other Customer Service', value: 126, checked: false }
    ]
}), new TreeviewItem({
    text: 'Data Management', checked: false, value: 141, collapsed: true, children: [
        { text: 'Data Archiving, Backup & Recovery', value: 142, checked: false },
        { text: 'Data Storage', value: 143, checked: false },
        { text: 'Database Management & Administration', value: 144, checked: false },
        { text: 'Electronic Document Management Systems (EDMS)', value: 145, checked: false },
        { text: 'Electronic Data Interchange (EDI)', value: 146, checked: false },
        { text: 'Data Integration', value: 147, checked: false },
        { text: 'API Management', value: 148, checked: false },
        { text: 'Databases', value: 149, checked: false },
        { text: 'Big Data Processing', value: 150, checked: false },
        { text: 'Other Data Management', value: 151, checked: false }
    ]
}), new TreeviewItem({
    text: 'Design', checked: false, value: 161, collapsed: true, children: [
        { text: 'Visualization', value: 162, checked: false },
        { text: 'Design and Publishing', value: 163, checked: false },
        { text: 'Computer Aided Design (CAD)', value: 164, checked: false },
        { text: 'Multimedia Design', value: 165, checked: false },
        { text: 'Other Design', value: 166, checked: false }
    ]
}), new TreeviewItem({
    text: 'Emerging Technologies', checked: false, value: 181, collapsed: true, children: [
        { text: 'Artificial Intelligence & Machine Learning', value: 182, checked: false },
        { text: 'Blockchain', value: 183, checked: false },
        { text: 'Internet of Things', value: 184, checked: false },
        { text: 'Other Emerging Technologies', value: 185, checked: false }
    ]
}), new TreeviewItem({
    text: 'Finance and Operations', checked: false, value: 201, collapsed: true, children: [
        { text: 'Order Management', value: 202, checked: false },
        { text: 'Enterprise Resource Planning (ERP)', value: 203, checked: false },
        { text: 'Enterprise Resource Planning (ERP)', value: 204, checked: false },
        { text: 'Accounting Software', value: 205, checked: false },
        { text: 'Procurement', value: 206, checked: false },
        { text: 'Travel and Expense Management', value: 207, checked: false },
        { text: 'Business Process Management (BPM)', value: 208, checked: false },
        { text: 'Inventory Management', value: 209, checked: false },
        { text: 'Supplier Relationship Management (SRM)', value: 210, checked: false },
        { text: 'Supply Chain Management (SCM)', value: 211, checked: false },
        { text: 'Asset Management', value: 212, checked: false },
        { text: 'Governance, Risk and Compliance (GRC)', value: 213, checked: false },
        { text: 'Project Management', value: 214, checked: false },
        { text: 'Project Management', value: 215, checked: false },
        { text: 'Accounts Payable', value: 216, checked: false },
        { text: 'Accounts Receivable and Billing', value: 217, checked: false },
        { text: 'Other Finance and Operations', value: 218, checked: false }
    ]
}), new TreeviewItem({
    text: 'Hardware', checked: false, value: 221, collapsed: true, children: [
        { text: 'Data Storage Hardware', value: 222, checked: false },
        { text: 'Personal Computers', value: 223, checked: false },
        { text: 'Other Hardware', value: 224, checked: false },
        { text: 'Mainframe Computers', value: 225, checked: false },
        { text: 'Midrange Computers', value: 226, checked: false },
        { text: 'Printers and Copiers', value: 227, checked: false },
        { text: 'Servers', value: 228, checked: false },
        { text: 'Network Hardware', value: 229, checked: false }
    ]
}), new TreeviewItem({
    text: 'Human Resources', checked: false, value: 241, collapsed: true, children: [
        { text: 'Human Resource Management Systems (HRMS)', value: 242, checked: false },
        { text: 'Case Management', value: 243, checked: false },
        { text: 'Learning Management Systems (LMS)', value: 244, checked: false },
        { text: 'Talent Management', value: 245, checked: false },
        { text: 'Workforce Management', value: 246, checked: false },
        { text: 'Time Tracking', value: 247, checked: false },
        { text: 'Payroll and Benefit Management', value: 248, checked: false },
        { text: 'Other Human Resources', value: 249, checked: false }
    ]
}), new TreeviewItem({
    text: 'Industry Specific Software', checked: false, value: 261, collapsed: true, children: [
        { text: 'Media & Entertainment Software', value: 262, checked: false },
        { text: 'Academic/Education Software', value: 263, checked: false },
        { text: 'Construction Management', value: 264, checked: false },
        { text: 'Legal Management', value: 265, checked: false },
        { text: 'Manufacturing', value: 266, checked: false },
        { text: 'Healthcare Management', value: 267, checked: false },
        { text: 'Non Profit', value: 268, checked: false },
        { text: 'Real Estate Management', value: 269, checked: false },
        { text: 'Environmental Health and Safety Management', value: 270, checked: false },
        { text: 'Financial Services and Insurance', value: 271, checked: false },
        { text: 'Life Sciences / Pharmaceutical', value: 272, checked: false },
        { text: 'Agriculture', value: 273, checked: false },
        { text: 'Energy, Utilities, Oil and Gas', value: 274, checked: false },
        { text: 'Hospitality and Food', value: 275, checked: false },
        { text: 'Engineering Management', value: 276, checked: false },
        { text: 'Other Industry Specific Software', value: 277, checked: false },
        { text: 'Transportation and Warehousing', value: 278, checked: false }
    ]
}), new TreeviewItem({
    text: 'IT Infrastructure / Management', checked: false, value: 281, collapsed: true, children: [
        { text: 'Cloud Infrastructure Management', value: 282, checked: false },
        { text: 'Infrastructure as a Service (IaaS)', value: 283, checked: false },
        { text: 'Platform as a Service (PaaS)', value: 284, checked: false },
        { text: 'Enterprise Mobility Management', value: 285, checked: false },
        { text: 'Mobile Device Management', value: 286, checked: false },
        { text: 'IT Operations Management', value: 287, checked: false },
        { text: 'Operating Systems', value: 288, checked: false },
        { text: 'Disaster Recovery (DR)', value: 289, checked: false },
        { text: 'IT Resource Management', value: 290, checked: false },
        { text: 'Network Management', value: 291, checked: false },
        { text: 'Workflow Automation', value: 292, checked: false },
        { text: 'Server Management', value: 293, checked: false },
        { text: 'Virtualization', value: 294, checked: false },
        { text: 'Remote Desktop', value: 295, checked: false },
        { text: 'Infrastructure as a Service (IaaS)', value: 296, checked: false },
        { text: 'IT Service Management (ITSM)', value: 297, checked: false },
        { text: 'Application Servers', value: 298, checked: false },
        { text: 'Other IT Infrastructure / Management', value: 299, checked: false }
    ]
}), new TreeviewItem({
    text: 'Marketing', checked: false, value: 305, collapsed: true, children: [
        { text: 'Marketing Performance Management', value: 306, checked: false },
        { text: 'Social Media Marketing', value: 307, checked: false },
        { text: 'Search Engine Optimization (SEO)', value: 308, checked: false },
        { text: 'Personalization', value: 309, checked: false },
        { text: 'Email Marketing', value: 310, checked: false },
        { text: 'ABM Software', value: 311, checked: false },
        { text: 'Content Marketing', value: 312, checked: false },
        { text: 'Customer Data Platform', value: 313, checked: false },
        { text: 'Marketing Automation', value: 314, checked: false },
        { text: 'Demand Generation', value: 315, checked: false },
        { text: 'Feedbacks and Reviews', value: 316, checked: false },
        { text: 'Other Marketing', value: 317, checked: false }
    ]
}), new TreeviewItem({
    text: 'Product Engineering and Development', checked: false, value: 321, collapsed: true, children: [
        { text: 'Programming Languages', value: 322, checked: false },
        { text: 'Product Lifecycle Management (PLM)', value: 323, checked: false },
        { text: 'Source Code Management', value: 324, checked: false },
        { text: 'Quality Assurance', value: 325, checked: false },
        { text: 'Configuration Management', value: 326, checked: false },
        { text: 'Application Development Tools', value: 327, checked: false },
        { text: 'Other Product Engineering and Development', value: 328, checked: false },
        { text: 'Container Orchestration', value: 329, checked: false },
        { text: 'Continuous Integration and Delivery', value: 330, checked: false },
        { text: 'Error and Exception Monitoring', value: 331, checked: false },
        { text: 'Frameworks and Libraries', value: 332, checked: false },
        { text: 'Message Queues', value: 333, checked: false },
        { text: 'Log Management', value: 334, checked: false },
        { text: 'Integrated Development Environments (IDE)', value: 335, checked: false }
    ]
}), new TreeviewItem({
    text: 'Sales', checked: false, value: 341, collapsed: true, children: [
        { text: 'Customer Relationship Management (CRM)', value: 342, checked: false },
        { text: 'Partner Relationship Management (PRM)', value: 343, checked: false },
        { text: 'Sales Intelligence', value: 344, checked: false },
        { text: 'Sales Acceleration', value: 345, checked: false },
        { text: 'Configure Price Quote', value: 346, checked: false },
        { text: 'Sales Analytics', value: 347, checked: false },
        { text: 'Other Sales', value: 348, checked: false }
    ]
}), new TreeviewItem({
    text: 'Security', checked: false, value: 361, collapsed: true, children: [
        { text: 'Security Information and Event Management (SIEM)', value: 362, checked: false },
        { text: 'Identity and Access Management (IAM)', value: 363, checked: false },
        { text: 'IT Security', value: 364, checked: false },
        { text: 'Identity and Access Management (IAM)', value: 365, checked: false },
        { text: 'SSL Certificates', value: 366, checked: false },
        { text: 'DDoS and Bot Protection', value: 367, checked: false },
        { text: 'Web Firewalls', value: 368, checked: false },
        { text: 'Endpoint Protection', value: 369, checked: false },
        { text: 'Email Security', value: 370, checked: false },
        { text: 'Other Security', value: 371, checked: false },
        { text: 'Data Security & Data Loss Prevention (DLP)', value: 372, checked: false },
        { text: 'Application Security & Testing', value: 373, checked: false },
        { text: 'Network Security', value: 374, checked: false },
        { text: 'Cloud & Cybersecurity', value: 375, checked: false }
    ]
})];

@Injectable({
    providedIn: 'root'
})
export class TechIntelCategoryDataService {
    constructor(private baseApiService: BaseApiService) { }

    getTechIntelCategoryData(): Observable<any> {
        return this.baseApiService.get('service/contactcloud/techno/categories', { showError: true });
    }
}
